module.exports = __webpack_public_path__ + "media/src/img/payment/bogdasha-602ff2e8cb510983d60738380ad9347f.svg";